//Include Both Helper File with needed methods


import { createAsyncThunk } from '@reduxjs/toolkit';
import { GetUser, login,updateUser, updateUser1 } from '../../../fakebackend_helper';
import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';

export const loginUser = (user, navigate) => async (dispatch) => {
  try {
    const response = await login({
      email: user.email,
      password: user.password,
    });

    const data = response;

    console.log(data.status);

    if (data.status === "SUCCESS") {
      sessionStorage.setItem("authUser", JSON.stringify(data));
      dispatch(loginSuccess(data));

      console.log("navigating to /dailyPlan");
      navigate('/dailyPlan'); // Assure-toi que c’est bien useNavigate()
    } else {
      dispatch(apiError(data.data));
    }
  } catch (error) {
    console.error("Login failed", error);
    dispatch(apiError(error.response?.data || error.message));
  }
};




export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};


export const GetUserServices = createAsyncThunk(
  'profil/fetchuser',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await GetUser(userId);
      return response.data;
    } catch (error) {
      // Renvoie l'erreur avec rejectWithValue pour une meilleure gestion
      return rejectWithValue(error.response?.data || 'Erreur lors du chargement des objectifs');
    }
  }
);

export const UpdateUserService = createAsyncThunk(
  "user/update",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await updateUser(userData);
      return response.data; // Retourne les données mises à jour
    } catch (error) {
      return rejectWithValue(error.response?.data || "Erreur lors de la mise à jour");
    }
  }
);
export const UpdateUserService1 = createAsyncThunk(
  "user/update",
  async ({ userId, ...userData }, { rejectWithValue }) => {
    try {
      const response = await updateUser1(userId, userData);
      return response.data; // Retourne les données mises à jour
    } catch (error) {
      return rejectWithValue(error.response?.data || "Erreur lors de la mise à jour");
    }
  }
);